import { ChartType } from "../report/entities/reportEntity";
import * as charts from "../report/charts";

import provinceModel from "../report/models/map/province";
import miniIpcCount from "../report/models/ipc/miniIpcCount";

export const WARNING_PROJECT_ID = 502282198319104;
export const TECH_FIELD = "category503528409923584";
export const COMP_FIELD = "category503530020536320";
export const CORE_PATENT_FIELD = "enum_01";

export const WARNING_REPOPRTS: any = {
  countryAndTypeModel: {
    definition: {
      rowDims: [{ name: "patentType", label: "类型", needTotal: true }],
      colDims: [{ name: "country", label: "申请国", limit: 10, needTotal: true }],
      measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
      condition: {
        items: [
          {
            name: "patentType",
            operator: "NOT_NULL",
          },
          {
            name: "country",
            operator: "NOT_NULL",
          },
        ],
      },
      showNoDataDims: true,
    },
  },
  appYearModel: {
    label: "年度申请量分析",
    chart: charts.lineAndBar,
    definition: {
      rowDims: [{ name: "appDate", label: "申请年", dateUnit: "YEAR", limit: 10, needTotal: true }],
      colDims: [],
      measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
      condition: {
        items: [
          {
            name: "appDate",
            operator: "NOT_NULL",
          },
        ],
      },
      showNoDataDims: true,
    },
    chartOption: {
      chartType: ChartType.LINE,
      title: "年度申请量分析",
      subTitle: "",
      hideTitle: true,
      xaxisTitle: "",
      yaxisTitle: "申请量",
      hideAxisTitle: false,
      hideLabel: false,
      hideLegend: false,
      hideToolbox: true,
    },
  },
  patenteeModel: {
    definition: {
      rowDims: [{ name: "patentee", label: "权利人", limit: 20, needTotal: true }],
      colDims: [{ name: "patentType", label: "类型", needTotal: true }],
      measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
      condition: {
        items: [
          {
            name: "patentee",
            operator: "NOT_NULL",
          },
          {
            name: "patentType",
            operator: "NOT_NULL",
          },
        ],
      },
      showNoDataDims: true,
    },
  },
  provinceModel: provinceModel,
  miniIpcCountModel: miniIpcCount,
};
